const AboutHero = () => {
  return (
    <section className="pt-32 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
              ABOUT IRS VENTURES
            </p>
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-navy-primary mb-10 leading-tight">
              Physician-Led Strategic Consulting
            </h1>

            <p className="text-lg text-charcoal leading-relaxed mb-8">
              IRS Ventures LLC is a Kentucky-established management and
              marketing consulting firm specializing in supporting clinical
              practices and standalone clinical groups with operational
              optimization, digital transformation, and patient growth
              strategies.
            </p>

            <p className="text-base text-charcoal leading-relaxed mb-8">
              We partner with physicians and clinical operators to streamline
              operations, reduce administrative burden, modernize digital
              infrastructure, implement scalable systems, strengthen patient
              outreach, and design sustainable practice growth strategies.
            </p>

            <div className="border-l-4 border-gold pl-6 py-4 bg-gray-bg/50 rounded-r-lg">
              <p className="font-serif text-lg italic text-navy-primary leading-relaxed">
                Our mission is to support clinical practices in building modern,
                efficient, scalable operational models through strategic
                consulting, digital enablement, and structured growth
                frameworks.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/4510fe87a4e5a2a95a4a9ebc106f6983.jpg"
                alt="Strategic Consulting Visualization"
                className="w-full h-auto rounded-3xl shadow-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;